module.exports = __webpack_public_path__ + "static/media/volume.d8d169b4.svg";